import React from "react";
import NotFound from "../../components/NotFound/NotFound";

function Home() {
  return <NotFound />;
}

export default Home;